import * as React from 'react';
import { ButtonGroup } from 'reactstrap';

interface FilterButtonGroupProps {
	children: React.ReactNode;
}

/**
 * Component for filter list field group
 */
export default function FiltersListButtonGroup(props: FilterButtonGroupProps) {
	return (
		<ButtonGroup size="sm" className="filters-list-item">
			{props.children}
		</ButtonGroup>
	);
}
